import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'

import { FooterLinkList } from './ui/footer-link/view'

export function Footer() {
    const { i18n } = useI18n()

    return (
        <footer
            className={css({
                fontSize: '[14px]',
                lineHeight: '[24px]',
                display: {
                    base: 'none',
                    lg: 'flex',
                },
                justifyContent: 'space-between',
                gap: '4',
                width: 'full',
                position: 'fixed',
                zIndex: 2,
                bottom: '0',
                paddingX: '3',
                paddingY: '1',
                color: 'footer.font',
                backgroundColor: 'footer.background',
                margin: '0',
            })}
        >
            <div>
                <div>{i18n.PORTAL_COPYRIGHT_FULL}</div>
            </div>
            <FooterLinkList />
        </footer>
    )
}
